import { Routes } from '@angular/router';

// layouts
import { AppLayout } from './layouts/app-layout';
import { AuthGuard } from './core/guards/auth.guards';

export const routes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/home/index.module').then((d) => d.IndexModule),
    },
    {
        path: 'gerenciamento',
        component: AppLayout,
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/gerenciamento/gerenciamento.module').then((d) => d.GerenciamentoModule),
    },
    {
        path: 'cadastro',
        component: AppLayout,
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/cadastro/cadastro.module').then((d) => d.CadastroModule),
    },
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then((d) => d.AuthModule),
    },
];
